<template>
    <el-main>
        <div class="handle-box">
            <el-button type="primary" icon="el-icon-plus" class="mr10" @click="showCreateDrawer">添加</el-button>
            <el-input v-model="query.keyword" placeholder="关键字" clearable @clear="handleSearch" class="handle-input mr10"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </div>

        <el-table :data="tableData" class="table100">
            <template v-for="row in tableFields">
                <template v-if="row.id != 'operation'">
                    <el-table-column
                        :key="row.id"
                        :prop="row.id"
                        :label="row.label"
                        :width="row.width"
                    ></el-table-column>
                </template>
                <template v-else>
                    <el-table-column :key="row.id" :label="row.label" width="row.width">
                        <template slot-scope="scope">
                            <template v-for="btn in row.buttons">
                                <el-button
                                    :key="btn.label"
                                    @click="actions(scope.row, btn.action)"
                                    :type="btn.type"
                                    :size="btn.size"
                                >{{btn.label}}</el-button>
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </template>
        </el-table>

        <el-drawer title="编辑部门信息" :visible.sync="editDrawer" direction="rtl" custom-class="drawer-right-side">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="部门名称" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>
                <el-form-item label="上/下线" prop="status">
                    <el-select v-model="ruleForm.status" placeholder="上/下线">
                        <el-option label="上线" value="normarl"></el-option>
                        <el-option label="下线" value="hidden"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="排序" prop="weigh">
                    <el-input v-model="ruleForm.weigh"></el-input>
                </el-form-item>

                <el-form-item>
                    <input type="hidden" name="id" v-model="ruleForm.id" />
                    <el-button type="primary" @click="saveEditDrawer">保存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>

        <el-drawer title="添加部门信息" :visible.sync="createDrawer" direction="rtl" custom-class="drawer-right-side">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="部门名称" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>
                <el-form-item label="上/下线" prop="status">
                    <el-select v-model="ruleForm.status" placeholder="上/下线">
                        <el-option label="上线" value="normarl"></el-option>
                        <el-option label="下线" value="hidden"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="排序" prop="weigh">
                    <el-input v-model="ruleForm.weigh"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="saveCreateDrawer">保存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
    </el-main>
</template>

<style>
.table-100 {
    width: 100%;
}
</style>
<script>
export default {
    name: 'Main',
    data() {
        return {
            query: {
                keyword: ''
            },
            createDrawer: false,
            editDrawer: false,

            tableFields: [],
            tableData: [],

            ruleForm: {
                id: 0,
                title: '',
                status: '',
                sort: 0
            },
            rules: {
                title: [
                    { required: true, message: '请输入部门名称', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ]
            }
        };
    },
    created: function() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            let url = '/api/organize.department/index';
            let query = this.query;
            this.$post(url, query).then(function(response) {
                let result = response.data;
                that.tableFields = result.fields;
                that.tableData = result.list;
            });
        },
        actions(row, action) {
            switch (action) {
                case 'edit':
                    this.showEditDrawer(row);
                    break;
                case 'visit':
                    this.visitDrawer = true;
                    break;
            }
        },
        handleSearch() {
            this.getTableData();
        },
        showCreateDrawer() {
            this.resetRuleForm();
            this.createDrawer = true;
        },
        saveCreateDrawer() {
            let url = '/api/organize.department/create';
            this.saveDrawer(url, 'createDrawer');
        },
        showEditDrawer(row) {
            this.editDrawer = true;
            this.ruleForm = row;
        },
        saveEditDrawer() {
            let url = '/api/organize.department/save';
            this.saveDrawer(url, 'editDrawer');
        },
        saveDrawer(url, drawer) {
            let that = this;
            let query = this.ruleForm;
            this.$post(url, query).then(function(response) {
                if (response.code == '200') {
                    // 如果是创建情况 需要重新加载
                    if (drawer == 'createDrawer') {
                        that.getTableData();
                    }

                    that.$message({
                        message: response.msg,
                        type: 'success'
                    });
                    that.resetRuleForm();
                    that[drawer] = false;
                } else {
                    that.$message.error(response.msg);
                }
            });
        },
        resetRuleForm() {
            this.ruleForm = {
                id: 0,
                title: '',
                status: '',
                sort: 0
            };
        }
    }
};
</script>